import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../../services/api.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CustomerRegisterFormComponent } from '../customer-register-form/customer-register-form.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-customer-dropdown',
  templateUrl: './customer-dropdown.component.html',
  styleUrls: ['./customer-dropdown.component.scss'],
  imports: [FormsModule, CommonModule,CustomerRegisterFormComponent]
})
export class CustomerDropdownComponent implements OnInit {
  customers: any[] = [];
  selectedCustomer: string = '';
  showRegisterForm = false;
  @Output() customerSelected = new EventEmitter<any>();

  // Searchable dropdown
  searchText: string = '';
  showDropdown: boolean = false;
  filteredCustomers: any[] = [];
  activeIndex: number = -1;

  constructor(private http: HttpClient, private apiService: ApiService, private dialog: MatDialog, private router: Router) {}

  ngOnInit() {
    this.fetchCustomers();
  }

  onFocus(): void {
    this.filteredCustomers = this.customers;
    this.showDropdown = true;
    this.activeIndex = -1;
  }

  onBlur(): void {
    // Delay to allow mousedown on option to fire first
    setTimeout(() => { this.showDropdown = false; }, 200);
  }

  onSearchInput(): void {
    const q = this.searchText.toLowerCase().trim();
    this.filteredCustomers = q
      ? this.customers.filter(c => this.getCustomerDisplayName(c).toLowerCase().includes(q))
      : this.customers;
    this.showDropdown = true;
    this.activeIndex = -1;
  }

  onKeydown(event: KeyboardEvent): void {
    if (!this.showDropdown) return;
    if (event.key === 'ArrowDown') {
      this.activeIndex = Math.min(this.activeIndex + 1, this.filteredCustomers.length - 1);
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      this.activeIndex = Math.max(this.activeIndex - 1, 0);
      event.preventDefault();
    } else if (event.key === 'Enter' && this.activeIndex >= 0) {
      this.selectCustomer(this.filteredCustomers[this.activeIndex]);
      event.preventDefault();
    } else if (event.key === 'Escape') {
      this.showDropdown = false;
    }
  }

  selectCustomer(customer: any): void {
    this.selectedCustomer = customer.customers_id;
    this.searchText = this.getCustomerDisplayName(customer);
    this.showDropdown = false;
    this.customerSelected.emit(customer);
  }

  clearSelection(event: MouseEvent): void {
    event.preventDefault();
    this.searchText = '';
    this.selectedCustomer = '';
    this.filteredCustomers = this.customers;
    this.customerSelected.emit(null);
  }

//   fetchCustomers() {
//   const team = this.getUserTeam();
//   this.apiService.getCustomer(`get-customers.php?team=${team}`)
//     .subscribe({
//       next: (response: any) => {
//         if (response.status === 'success') {
//           this.customers = response.data.sort((a: any, b: any) => {
//             const nameA = this.getCustomerDisplayName(a).toLowerCase();
//             const nameB = this.getCustomerDisplayName(b).toLowerCase();
//             if (nameA < nameB) return -1;
//             if (nameA > nameB) return 1;
//             return 0;
//           });
//         }
//       },
//       error: (error) => {
//         console.error('Error fetching customers:', error);
//       }
//     });
// }
// ----------customer register-----------
 navigateToRegister() {
    this.router.navigate(['customers/signup']); // Update with your actual route
  }
// navigateToRegister() {
//   const dialogRef = this.dialog.open(CustomerRegisterFormComponent, {
//     width: '500px',
//     maxWidth: '98vw',
//     maxHeight: '68vh',
//     panelClass: 'customer-register-dialog'
//   });
//   dialogRef.afterClosed().subscribe(result => {
//     if (result === 'success') {
//       this.fetchCustomers(); 
//     }
//   });
// }
// ---------------------------------------

  // onCustomerSelect() {
  //   const selected = this.customers.find(c => c.customers_id === this.selectedCustomer);
  //   this.customerSelected.emit(selected);
  // }
onCustomerSelect() {
  if (this.selectedCustomer) {
    const customer = this.customers.find(c => c.customers_id === this.selectedCustomer);
    if (customer) {
      this.customerSelected.emit(customer);
    }
  } else {
    this.customerSelected.emit(null); 
  }
}
  getCustomerDisplayName(customer: any): string {
    return customer.customers_company ? customer.customers_company : customer.customers_id;
  }

  private getUserTeam(): string {
    const userInfoString = localStorage.getItem('userInfo');
    if (!userInfoString) return 'salesnorth';
    
    const userInfo = JSON.parse(userInfoString);
    return userInfo['custom:team'] || 'salesnorth';
  }

  // Add this method to CustomerDropdownComponent
private restoreSelectedCustomer(): void {
  try {
    const savedCustomer = localStorage.getItem('studioip_selected_customer');
    if (savedCustomer) {
      const customerData = JSON.parse(savedCustomer);
      const isExpired = Date.now() - customerData.timestamp > 24 * 60 * 60 * 1000;
      
      if (!isExpired && customerData.id) {
        // Find the customer in the list
        const foundCustomer = this.customers.find(
          c => c.customers_id === customerData.id
        );
        
        if (foundCustomer) {
          this.selectedCustomer = customerData.id;
          this.searchText = this.getCustomerDisplayName(foundCustomer);

          // Emit the event to parent component
          setTimeout(() => {
            this.customerSelected.emit(foundCustomer);
          }, 100);
        }
      }
    }
  } catch (error) {
    console.error('Error restoring selected customer:', error);
  }
}


// Update the fetchCustomers method
fetchCustomers() {
  const team = this.getUserTeam();
  this.apiService.getCustomer(`get-customers.php?team=${team}`)
    .subscribe({
      next: (response: any) => {
        if (response.status === 'success') {
          this.customers = response.data.sort((a: any, b: any) => {
            const nameA = this.getCustomerDisplayName(a).toLowerCase();
            const nameB = this.getCustomerDisplayName(b).toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
          this.filteredCustomers = [...this.customers];

          // Restore selected customer after customers are loaded
          this.restoreSelectedCustomer();
        }
      },
      error: (error) => {
        console.error('Error fetching customers:', error);
      }
    });
}
}
